type BookPlaceholderProps = {
  quantity?: number;
  className?: string; // Propriedade opcional
};

export function BookPlaceholder({ quantity = 1, className }: BookPlaceholderProps) {
  return (
      <>
        {Array.from({ length: quantity }).map((_, index) => (
        <div className={`placeholder-glow ${className}`} key={index}>
          <span className="link-livro">
            <div className="livro livro-placeholder placeholder"></div>
          </span>
        </div>
      ))}
      </>
  );
}
